import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { bootstrapProviders } from './app/app-bootstrap.providers';
import { protectSignedFileLinks } from './app/core/signed-file-links';

protectSignedFileLinks(document);
bootstrapApplication(AppComponent, {
  providers: [provideZoneChangeDetection(), ...bootstrapProviders],
}).catch(err => console.error(err));
